// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file schema/v1/schema.proto (package schema.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file schema/v1/schema.proto.
 */
export const file_schema_v1_schema: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message schema.v1.GetRequest
 */
export type GetRequest = Message<"schema.v1.GetRequest"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;
};

/**
 * Describes the message schema.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 0);

/**
 * @generated from message schema.v1.GetResponse
 */
export type GetResponse = Message<"schema.v1.GetResponse"> & {
  /**
   * @generated from field: schema.v1.Schema schema = 1;
   */
  schema?: Schema | undefined;
};

/**
 * Describes the message schema.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 1);

/**
 * @generated from message schema.v1.CreateRequest
 */
export type CreateRequest = Message<"schema.v1.CreateRequest"> & {
  /**
   * @generated from field: schema.v1.Schema schema = 1;
   */
  schema?: Schema | undefined;
};

/**
 * Describes the message schema.v1.CreateRequest.
 * Use `create(CreateRequestSchema)` to create a new message.
 */
export const CreateRequestSchema: GenMessage<CreateRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 2);

/**
 * @generated from message schema.v1.CreateResponse
 */
export type CreateResponse = Message<"schema.v1.CreateResponse"> & {
  /**
   * @generated from field: schema.v1.Schema schema = 1;
   */
  schema?: Schema | undefined;
};

/**
 * Describes the message schema.v1.CreateResponse.
 * Use `create(CreateResponseSchema)` to create a new message.
 */
export const CreateResponseSchema: GenMessage<CreateResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 3);

/**
 * @generated from message schema.v1.UpdateRequest
 */
export type UpdateRequest = Message<"schema.v1.UpdateRequest"> & {
  /**
   * @generated from field: schema.v1.Schema schema = 1;
   */
  schema?: Schema | undefined;
};

/**
 * Describes the message schema.v1.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema: GenMessage<UpdateRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 4);

/**
 * @generated from message schema.v1.UpdateResponse
 */
export type UpdateResponse = Message<"schema.v1.UpdateResponse"> & {
  /**
   * @generated from field: schema.v1.Schema schema = 1;
   */
  schema?: Schema | undefined;
};

/**
 * Describes the message schema.v1.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema: GenMessage<UpdateResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 5);

/**
 * @generated from message schema.v1.DeleteRequest
 */
export type DeleteRequest = Message<"schema.v1.DeleteRequest"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;
};

/**
 * Describes the message schema.v1.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 6);

/**
 * @generated from message schema.v1.DeleteResponse
 */
export type DeleteResponse = Message<"schema.v1.DeleteResponse"> & {
};

/**
 * Describes the message schema.v1.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema: GenMessage<DeleteResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 7);

/**
 * @generated from message schema.v1.ListRequest
 */
export type ListRequest = Message<"schema.v1.ListRequest"> & {
};

/**
 * Describes the message schema.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 8);

/**
 * @generated from message schema.v1.ListResponse
 */
export type ListResponse = Message<"schema.v1.ListResponse"> & {
  /**
   * @generated from field: repeated schema.v1.Schema schemas = 1;
   */
  schemas: Schema[];
};

/**
 * Describes the message schema.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 9);

/**
 * @generated from message schema.v1.ValidateRequest
 */
export type ValidateRequest = Message<"schema.v1.ValidateRequest"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * JSON payload to validate
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message schema.v1.ValidateRequest.
 * Use `create(ValidateRequestSchema)` to create a new message.
 */
export const ValidateRequestSchema: GenMessage<ValidateRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 10);

/**
 * @generated from message schema.v1.ValidateResponse
 */
export type ValidateResponse = Message<"schema.v1.ValidateResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: repeated schema.v1.ValidationError errors = 2;
   */
  errors: ValidationError[];
};

/**
 * Describes the message schema.v1.ValidateResponse.
 * Use `create(ValidateResponseSchema)` to create a new message.
 */
export const ValidateResponseSchema: GenMessage<ValidateResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 11);

/**
 * Definition is a data-dictionary definition of any kind (entity_type,
 * relationship_type, lifecycle, view, event_type), carrying its JSON payload and
 * the revision backing optimistic-concurrency writes. This is what makes the
 * dictionary self-describing — every definition is retrievable as an entity.
 *
 * @generated from message schema.v1.Definition
 */
export type Definition = Message<"schema.v1.Definition"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: uint64 revision = 4;
   */
  revision: bigint;

  /**
   * Versioned-envelope metadata (HUB-365), populated for migrated kinds only:
   * monotonic version per (kind, id), definition status
   * (draft|staged|active|deprecated), the actor who authored the version, and
   * the actor who last promoted it.
   *
   * @generated from field: int64 version = 5;
   */
  version: bigint;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string author = 7;
   */
  author: string;

  /**
   * @generated from field: string promoter = 8;
   */
  promoter: string;

  /**
   * node_selector scopes a canary activation (HUB-365 slice 2, Q5): when
   * non-empty, only nodes whose runtime labels match every entry apply this
   * version; other nodes keep the unlabeled base active version.
   *
   * @generated from field: map<string, string> node_selector = 9;
   */
  nodeSelector: { [key: string]: string };
};

/**
 * Describes the message schema.v1.Definition.
 * Use `create(DefinitionSchema)` to create a new message.
 */
export const DefinitionSchema: GenMessage<Definition> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 12);

/**
 * @generated from message schema.v1.PutDefinitionRequest
 */
export type PutDefinitionRequest = Message<"schema.v1.PutDefinitionRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: uint64 expected_revision = 4;
   */
  expectedRevision: bigint;

  /**
   * Required for migrated kinds (HUB-365): the writing principal and the
   * free-text justification recorded on the CONFIG audit stream. Reasons are
   * Internal data - never include PHI.
   *
   * @generated from field: string actor = 5;
   */
  actor: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message schema.v1.PutDefinitionRequest.
 * Use `create(PutDefinitionRequestSchema)` to create a new message.
 */
export const PutDefinitionRequestSchema: GenMessage<PutDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 13);

/**
 * @generated from message schema.v1.PutDefinitionResponse
 */
export type PutDefinitionResponse = Message<"schema.v1.PutDefinitionResponse"> & {
  /**
   * @generated from field: uint64 revision = 1;
   */
  revision: bigint;

  /**
   * Populated for migrated kinds: the draft version written, its status
   * ("draft"), and any non-blocking validation warnings (warnings block
   * promotion, not draft saves).
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: repeated string warnings = 4;
   */
  warnings: string[];
};

/**
 * Describes the message schema.v1.PutDefinitionResponse.
 * Use `create(PutDefinitionResponseSchema)` to create a new message.
 */
export const PutDefinitionResponseSchema: GenMessage<PutDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 14);

/**
 * @generated from message schema.v1.PromoteDefinitionRequest
 */
export type PromoteDefinitionRequest = Message<"schema.v1.PromoteDefinitionRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * The promoting principal and required justification (audited).
   *
   * @generated from field: string actor = 3;
   */
  actor: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * When set while promoting a staged version, activates as a canary scoped to
   * nodes whose runtime labels match every entry (HUB-365 slice 2, Q5). Empty
   * means a full (all-nodes) activation.
   *
   * @generated from field: map<string, string> node_selector = 5;
   */
  nodeSelector: { [key: string]: string };
};

/**
 * Describes the message schema.v1.PromoteDefinitionRequest.
 * Use `create(PromoteDefinitionRequestSchema)` to create a new message.
 */
export const PromoteDefinitionRequestSchema: GenMessage<PromoteDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 15);

/**
 * @generated from message schema.v1.PromoteDefinitionResponse
 */
export type PromoteDefinitionResponse = Message<"schema.v1.PromoteDefinitionResponse"> & {
  /**
   * The definition after promotion (version + new status; node_selector set on
   * a canary activation).
   *
   * @generated from field: schema.v1.Definition definition = 1;
   */
  definition?: Definition | undefined;
};

/**
 * Describes the message schema.v1.PromoteDefinitionResponse.
 * Use `create(PromoteDefinitionResponseSchema)` to create a new message.
 */
export const PromoteDefinitionResponseSchema: GenMessage<PromoteDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 16);

/**
 * @generated from message schema.v1.AbandonCanaryRequest
 */
export type AbandonCanaryRequest = Message<"schema.v1.AbandonCanaryRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string actor = 3;
   */
  actor: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message schema.v1.AbandonCanaryRequest.
 * Use `create(AbandonCanaryRequestSchema)` to create a new message.
 */
export const AbandonCanaryRequestSchema: GenMessage<AbandonCanaryRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 17);

/**
 * @generated from message schema.v1.AbandonCanaryResponse
 */
export type AbandonCanaryResponse = Message<"schema.v1.AbandonCanaryResponse"> & {
};

/**
 * Describes the message schema.v1.AbandonCanaryResponse.
 * Use `create(AbandonCanaryResponseSchema)` to create a new message.
 */
export const AbandonCanaryResponseSchema: GenMessage<AbandonCanaryResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 18);

/**
 * @generated from message schema.v1.RollbackDefinitionRequest
 */
export type RollbackDefinitionRequest = Message<"schema.v1.RollbackDefinitionRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * The principal performing the rollback and the required justification
   * (audited on the CONFIG stream). Reasons are Internal data - never PHI.
   *
   * @generated from field: string actor = 3;
   */
  actor: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message schema.v1.RollbackDefinitionRequest.
 * Use `create(RollbackDefinitionRequestSchema)` to create a new message.
 */
export const RollbackDefinitionRequestSchema: GenMessage<RollbackDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 19);

/**
 * @generated from message schema.v1.RollbackDefinitionResponse
 */
export type RollbackDefinitionResponse = Message<"schema.v1.RollbackDefinitionResponse"> & {
  /**
   * The definition after rollback (the re-activated prior version, now active).
   *
   * @generated from field: schema.v1.Definition definition = 1;
   */
  definition?: Definition | undefined;
};

/**
 * Describes the message schema.v1.RollbackDefinitionResponse.
 * Use `create(RollbackDefinitionResponseSchema)` to create a new message.
 */
export const RollbackDefinitionResponseSchema: GenMessage<RollbackDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 20);

/**
 * @generated from message schema.v1.GetDefinitionHistoryRequest
 */
export type GetDefinitionHistoryRequest = Message<"schema.v1.GetDefinitionHistoryRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message schema.v1.GetDefinitionHistoryRequest.
 * Use `create(GetDefinitionHistoryRequestSchema)` to create a new message.
 */
export const GetDefinitionHistoryRequestSchema: GenMessage<GetDefinitionHistoryRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 21);

/**
 * @generated from message schema.v1.GetDefinitionHistoryResponse
 */
export type GetDefinitionHistoryResponse = Message<"schema.v1.GetDefinitionHistoryResponse"> & {
  /**
   * @generated from field: repeated schema.v1.ConfigAuditEntry entries = 1;
   */
  entries: ConfigAuditEntry[];
};

/**
 * Describes the message schema.v1.GetDefinitionHistoryResponse.
 * Use `create(GetDefinitionHistoryResponseSchema)` to create a new message.
 */
export const GetDefinitionHistoryResponseSchema: GenMessage<GetDefinitionHistoryResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 22);

/**
 * ConfigAuditEntry is one metadata-only record of the config audit trail
 * (HUB-406). It never carries the definition payload — field paths and rule
 * codes only, per the PHI-safe error rule.
 *
 * @generated from message schema.v1.ConfigAuditEntry
 */
export type ConfigAuditEntry = Message<"schema.v1.ConfigAuditEntry"> & {
  /**
   * Event type: config.created | config.updated | config.promoted |
   * config.deprecated | config.deleted.
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * The principal who performed the write.
   *
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * The version's author and the actor who last promoted it (recorded from day
   * 1; the author != promoter rule activates with distinct identities, Q4).
   *
   * @generated from field: string author = 6;
   */
  author: string;

  /**
   * @generated from field: string promoter = 7;
   */
  promoter: string;

  /**
   * RFC3339 timestamp.
   *
   * @generated from field: string timestamp = 8;
   */
  timestamp: string;

  /**
   * Set on a canary activation (Q5): the node selector the activation was
   * scoped to.
   *
   * @generated from field: map<string, string> node_selector = 9;
   */
  nodeSelector: { [key: string]: string };
};

/**
 * Describes the message schema.v1.ConfigAuditEntry.
 * Use `create(ConfigAuditEntrySchema)` to create a new message.
 */
export const ConfigAuditEntrySchema: GenMessage<ConfigAuditEntry> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 23);

/**
 * @generated from message schema.v1.GetDefinitionRequest
 */
export type GetDefinitionRequest = Message<"schema.v1.GetDefinitionRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * For migrated kinds: which status slot to read - "active" (default),
   * "staged", or "draft". Ignored for unmigrated kinds.
   *
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message schema.v1.GetDefinitionRequest.
 * Use `create(GetDefinitionRequestSchema)` to create a new message.
 */
export const GetDefinitionRequestSchema: GenMessage<GetDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 24);

/**
 * @generated from message schema.v1.GetDefinitionResponse
 */
export type GetDefinitionResponse = Message<"schema.v1.GetDefinitionResponse"> & {
  /**
   * Unset when no definition exists for (kind, id).
   *
   * @generated from field: schema.v1.Definition definition = 1;
   */
  definition?: Definition | undefined;
};

/**
 * Describes the message schema.v1.GetDefinitionResponse.
 * Use `create(GetDefinitionResponseSchema)` to create a new message.
 */
export const GetDefinitionResponseSchema: GenMessage<GetDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 25);

/**
 * @generated from message schema.v1.ListDefinitionsRequest
 */
export type ListDefinitionsRequest = Message<"schema.v1.ListDefinitionsRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;
};

/**
 * Describes the message schema.v1.ListDefinitionsRequest.
 * Use `create(ListDefinitionsRequestSchema)` to create a new message.
 */
export const ListDefinitionsRequestSchema: GenMessage<ListDefinitionsRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 26);

/**
 * @generated from message schema.v1.ListDefinitionsResponse
 */
export type ListDefinitionsResponse = Message<"schema.v1.ListDefinitionsResponse"> & {
  /**
   * @generated from field: repeated schema.v1.Definition definitions = 1;
   */
  definitions: Definition[];
};

/**
 * Describes the message schema.v1.ListDefinitionsResponse.
 * Use `create(ListDefinitionsResponseSchema)` to create a new message.
 */
export const ListDefinitionsResponseSchema: GenMessage<ListDefinitionsResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 27);

/**
 * @generated from message schema.v1.DeleteDefinitionRequest
 */
export type DeleteDefinitionRequest = Message<"schema.v1.DeleteDefinitionRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message schema.v1.DeleteDefinitionRequest.
 * Use `create(DeleteDefinitionRequestSchema)` to create a new message.
 */
export const DeleteDefinitionRequestSchema: GenMessage<DeleteDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 28);

/**
 * @generated from message schema.v1.DeleteDefinitionResponse
 */
export type DeleteDefinitionResponse = Message<"schema.v1.DeleteDefinitionResponse"> & {
};

/**
 * Describes the message schema.v1.DeleteDefinitionResponse.
 * Use `create(DeleteDefinitionResponseSchema)` to create a new message.
 */
export const DeleteDefinitionResponseSchema: GenMessage<DeleteDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 29);

/**
 * @generated from message schema.v1.GetViewDefinitionRequest
 */
export type GetViewDefinitionRequest = Message<"schema.v1.GetViewDefinitionRequest"> & {
  /**
   * The view key (the view definition's id), e.g. "workitem_detail".
   *
   * @generated from field: string view_key = 1;
   */
  viewKey: string;

  /**
   * Which status slot to resolve: "active" (default, the consumable view) or
   * "staged" (a preview of the next version). "draft" is rejected — drafts are
   * authoring state, not consumable.
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message schema.v1.GetViewDefinitionRequest.
 * Use `create(GetViewDefinitionRequestSchema)` to create a new message.
 */
export const GetViewDefinitionRequestSchema: GenMessage<GetViewDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 30);

/**
 * @generated from message schema.v1.GetViewDefinitionResponse
 */
export type GetViewDefinitionResponse = Message<"schema.v1.GetViewDefinitionResponse"> & {
  /**
   * Unset when no view matches (the RPC returns NotFound in that case).
   *
   * @generated from field: schema.v1.ViewDefinition view = 1;
   */
  view?: ViewDefinition | undefined;
};

/**
 * Describes the message schema.v1.GetViewDefinitionResponse.
 * Use `create(GetViewDefinitionResponseSchema)` to create a new message.
 */
export const GetViewDefinitionResponseSchema: GenMessage<GetViewDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 31);

/**
 * @generated from message schema.v1.ListViewDefinitionsRequest
 */
export type ListViewDefinitionsRequest = Message<"schema.v1.ListViewDefinitionsRequest"> & {
  /**
   * Optional: restrict to views bound to this entity type. Empty returns all
   * active views.
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;
};

/**
 * Describes the message schema.v1.ListViewDefinitionsRequest.
 * Use `create(ListViewDefinitionsRequestSchema)` to create a new message.
 */
export const ListViewDefinitionsRequestSchema: GenMessage<ListViewDefinitionsRequest> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 32);

/**
 * @generated from message schema.v1.ListViewDefinitionsResponse
 */
export type ListViewDefinitionsResponse = Message<"schema.v1.ListViewDefinitionsResponse"> & {
  /**
   * @generated from field: repeated schema.v1.ViewDefinition views = 1;
   */
  views: ViewDefinition[];
};

/**
 * Describes the message schema.v1.ListViewDefinitionsResponse.
 * Use `create(ListViewDefinitionsResponseSchema)` to create a new message.
 */
export const ListViewDefinitionsResponseSchema: GenMessage<ListViewDefinitionsResponse> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 33);

/**
 * ViewDefinition is the structured, client-consumable projection of a `view`
 * dictionary definition (HUB-408): the HUB-277 binding renderer maps it to
 * view-primitive props (field order, labels, grouping, render hints). Access
 * hints are RENDER hints only ("render editable" vs "read-only"); authoritative
 * field access and PHI masking are enforced server-side (HUB-357).
 *
 * @generated from message schema.v1.ViewDefinition
 */
export type ViewDefinition = Message<"schema.v1.ViewDefinition"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Render primitive key (HUB-276): record | list | dashboard | form | ...
   *
   * @generated from field: string primitive = 3;
   */
  primitive: string;

  /**
   * Entity-type definition this view renders (may be empty: binds late).
   *
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * View-level access hint (read | write; empty means read).
   *
   * @generated from field: string access = 5;
   */
  access: string;

  /**
   * @generated from field: bool default = 6;
   */
  default: boolean;

  /**
   * Mount target (blade | pane | overlay; empty means blade).
   *
   * @generated from field: string mount = 7;
   */
  mount: string;

  /**
   * Presentation hint (explorer | focus; empty means inherit).
   *
   * @generated from field: string presentation = 8;
   */
  presentation: string;

  /**
   * @generated from field: repeated schema.v1.ViewDefinitionSection sections = 9;
   */
  sections: ViewDefinitionSection[];

  /**
   * Which versioned-envelope slot resolved (version + status).
   *
   * @generated from field: int64 version = 10;
   */
  version: bigint;

  /**
   * @generated from field: string status = 11;
   */
  status: string;
};

/**
 * Describes the message schema.v1.ViewDefinition.
 * Use `create(ViewDefinitionSchema)` to create a new message.
 */
export const ViewDefinitionSchema: GenMessage<ViewDefinition> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 34);

/**
 * @generated from message schema.v1.ViewDefinitionSection
 */
export type ViewDefinitionSection = Message<"schema.v1.ViewDefinitionSection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: repeated schema.v1.ViewDefinitionField fields = 3;
   */
  fields: ViewDefinitionField[];
};

/**
 * Describes the message schema.v1.ViewDefinitionSection.
 * Use `create(ViewDefinitionSectionSchema)` to create a new message.
 */
export const ViewDefinitionSectionSchema: GenMessage<ViewDefinitionSection> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 35);

/**
 * @generated from message schema.v1.ViewDefinitionField
 */
export type ViewDefinitionField = Message<"schema.v1.ViewDefinitionField"> & {
  /**
   * Entity field name this slot projects.
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * Label override (empty falls back to the schema field's label).
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Render-hint idiom (the Field.As idiom, e.g. "mono", "badge").
   *
   * @generated from field: string as = 3;
   */
  as: string;

  /**
   * Per-field access hint (read | write; empty inherits the view access).
   *
   * @generated from field: string access = 4;
   */
  access: string;
};

/**
 * Describes the message schema.v1.ViewDefinitionField.
 * Use `create(ViewDefinitionFieldSchema)` to create a new message.
 */
export const ViewDefinitionFieldSchema: GenMessage<ViewDefinitionField> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 36);

/**
 * Schema represents an event type schema definition.
 *
 * @generated from message schema.v1.Schema
 */
export type Schema = Message<"schema.v1.Schema"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: map<string, schema.v1.Field> fields = 5;
   */
  fields: { [key: string]: Field };
};

/**
 * Describes the message schema.v1.Schema.
 * Use `create(SchemaSchema)` to create a new message.
 */
export const SchemaSchema: GenMessage<Schema> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 37);

/**
 * Field represents a field definition within a schema.
 *
 * @generated from message schema.v1.Field
 */
export type Field = Message<"schema.v1.Field"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: bool required = 2;
   */
  required: boolean;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: optional int32 min_length = 4;
   */
  minLength?: number | undefined;

  /**
   * @generated from field: optional int32 max_length = 5;
   */
  maxLength?: number | undefined;

  /**
   * @generated from field: optional string pattern = 6;
   */
  pattern?: string | undefined;

  /**
   * @generated from field: optional double min = 7;
   */
  min?: number | undefined;

  /**
   * @generated from field: optional double max = 8;
   */
  max?: number | undefined;

  /**
   * @generated from field: optional bool integer = 9;
   */
  integer?: boolean | undefined;

  /**
   * @generated from field: optional schema.v1.Field items = 10;
   */
  items?: Field | undefined;

  /**
   * @generated from field: optional int32 min_items = 11;
   */
  minItems?: number | undefined;

  /**
   * @generated from field: optional int32 max_items = 12;
   */
  maxItems?: number | undefined;

  /**
   * @generated from field: map<string, schema.v1.Field> fields = 13;
   */
  fields: { [key: string]: Field };

  /**
   * @generated from field: repeated schema.v1.SelectOption options = 14;
   */
  options: SelectOption[];

  /**
   * @generated from field: optional string entity_type = 15;
   */
  entityType?: string | undefined;
};

/**
 * Describes the message schema.v1.Field.
 * Use `create(FieldSchema)` to create a new message.
 */
export const FieldSchema: GenMessage<Field> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 38);

/**
 * SelectOption represents a choice in a select or multi_select field.
 *
 * @generated from message schema.v1.SelectOption
 */
export type SelectOption = Message<"schema.v1.SelectOption"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message schema.v1.SelectOption.
 * Use `create(SelectOptionSchema)` to create a new message.
 */
export const SelectOptionSchema: GenMessage<SelectOption> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 39);

/**
 * ValidationError represents a single validation failure.
 *
 * @generated from message schema.v1.ValidationError
 */
export type ValidationError = Message<"schema.v1.ValidationError"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message schema.v1.ValidationError.
 * Use `create(ValidationErrorSchema)` to create a new message.
 */
export const ValidationErrorSchema: GenMessage<ValidationError> = /*@__PURE__*/
  messageDesc(file_schema_v1_schema, 40);

/**
 * SchemaService provides event schema management and validation.
 *
 * @generated from service schema.v1.SchemaService
 */
export const SchemaService: GenService<{
  /**
   * Get retrieves a schema by event type.
   *
   * @generated from rpc schema.v1.SchemaService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * Create registers a new schema.
   *
   * @generated from rpc schema.v1.SchemaService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateRequestSchema;
    output: typeof CreateResponseSchema;
  },
  /**
   * Update modifies an existing schema.
   *
   * @generated from rpc schema.v1.SchemaService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateRequestSchema;
    output: typeof UpdateResponseSchema;
  },
  /**
   * Delete removes a schema.
   *
   * @generated from rpc schema.v1.SchemaService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof DeleteResponseSchema;
  },
  /**
   * List returns all registered schemas.
   *
   * @generated from rpc schema.v1.SchemaService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * Validate checks a payload against a schema.
   *
   * @generated from rpc schema.v1.SchemaService.Validate
   */
  validate: {
    methodKind: "unary";
    input: typeof ValidateRequestSchema;
    output: typeof ValidateResponseSchema;
  },
  /**
   * PutDefinition creates or updates a dictionary definition of any kind
   * (entity_type, relationship_type, lifecycle, view). Optimistic concurrency:
   * expected_revision 0 creates; a non-zero value must match the current revision.
   *
   * For kinds migrated to the versioned dictionary write path (HUB-365 —
   * slice 1: lifecycle), actor and reason are REQUIRED, the write lands as a
   * DRAFT version (create-or-edit-in-place), is validated pre-flight, appended
   * to the CONFIG event stream, and synchronously projected before acking.
   *
   * @generated from rpc schema.v1.SchemaService.PutDefinition
   */
  putDefinition: {
    methodKind: "unary";
    input: typeof PutDefinitionRequestSchema;
    output: typeof PutDefinitionResponseSchema;
  },
  /**
   * PromoteDefinition advances a migrated-kind definition one lifecycle step
   * (draft -> staged, staged -> active) as a separately-audited action (HUB-365).
   * Requires the config:promote capability once the authz seam is wired.
   *
   * Canary activation (HUB-365 slice 2, Q5): when node_selector is set on the
   * request while promoting a staged version, the version activates as a
   * node-selector-scoped canary (the base active version stays for
   * non-matching nodes); a subsequent unlabeled promote completes the rollout.
   *
   * @generated from rpc schema.v1.SchemaService.PromoteDefinition
   */
  promoteDefinition: {
    methodKind: "unary";
    input: typeof PromoteDefinitionRequestSchema;
    output: typeof PromoteDefinitionResponseSchema;
  },
  /**
   * AbandonCanary removes an in-flight canary activation without completing the
   * rollout; canary nodes fall back to the base active version (HUB-365 slice 2).
   *
   * @generated from rpc schema.v1.SchemaService.AbandonCanary
   */
  abandonCanary: {
    methodKind: "unary";
    input: typeof AbandonCanaryRequestSchema;
    output: typeof AbandonCanaryResponseSchema;
  },
  /**
   * RollbackDefinition re-activates the base active version that immediately
   * preceded the current one, as a new audited config.promoted event (HUB-406,
   * design §5). Rollback is re-activation, not history rewrite; requires the
   * config:promote capability and a reason. FailedPrecondition when there is no
   * prior version to return to.
   *
   * @generated from rpc schema.v1.SchemaService.RollbackDefinition
   */
  rollbackDefinition: {
    methodKind: "unary";
    input: typeof RollbackDefinitionRequestSchema;
    output: typeof RollbackDefinitionResponseSchema;
  },
  /**
   * GetDefinitionHistory returns the CONFIG-stream audit trail for a migrated
   * definition — every create/update/promote/deprecate with actor, reason,
   * version, status, and timestamp, oldest first (HUB-406). The trail is
   * retained indefinitely (Audit/Security Record). Metadata only — payload
   * values are never returned.
   *
   * @generated from rpc schema.v1.SchemaService.GetDefinitionHistory
   */
  getDefinitionHistory: {
    methodKind: "unary";
    input: typeof GetDefinitionHistoryRequestSchema;
    output: typeof GetDefinitionHistoryResponseSchema;
  },
  /**
   * GetDefinition retrieves a definition by kind and id (schemas-as-entities).
   *
   * @generated from rpc schema.v1.SchemaService.GetDefinition
   */
  getDefinition: {
    methodKind: "unary";
    input: typeof GetDefinitionRequestSchema;
    output: typeof GetDefinitionResponseSchema;
  },
  /**
   * ListDefinitions lists all definitions of a kind.
   *
   * @generated from rpc schema.v1.SchemaService.ListDefinitions
   */
  listDefinitions: {
    methodKind: "unary";
    input: typeof ListDefinitionsRequestSchema;
    output: typeof ListDefinitionsResponseSchema;
  },
  /**
   * DeleteDefinition removes a definition by kind and id.
   *
   * @generated from rpc schema.v1.SchemaService.DeleteDefinition
   */
  deleteDefinition: {
    methodKind: "unary";
    input: typeof DeleteDefinitionRequestSchema;
    output: typeof DeleteDefinitionResponseSchema;
  },
  /**
   * GetViewDefinition resolves the active `view` definition for a view key and
   * returns it as a structured ViewDefinition the HUB-277 binding renderer
   * consumes (HUB-408) — sections of fields with label/render/access hints,
   * rather than the raw JSON GetDefinition returns. NotFound when no active view
   * exists for the key. Access hints are RENDER hints only; authoritative field
   * access and PHI masking stay server-side (HUB-357).
   *
   * @generated from rpc schema.v1.SchemaService.GetViewDefinition
   */
  getViewDefinition: {
    methodKind: "unary";
    input: typeof GetViewDefinitionRequestSchema;
    output: typeof GetViewDefinitionResponseSchema;
  },
  /**
   * ListViewDefinitions lists active view definitions, optionally filtered to a
   * single entity type (HUB-408).
   *
   * @generated from rpc schema.v1.SchemaService.ListViewDefinitions
   */
  listViewDefinitions: {
    methodKind: "unary";
    input: typeof ListViewDefinitionsRequestSchema;
    output: typeof ListViewDefinitionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_schema_v1_schema, 0);

